import React from 'react';
import { Container, Graphics } from '@pixi/react';

import MenuWrapper from '../../containers/common/menuWrapper';
import Notification from '../../containers/common/notification';
import MobileFooterContainer from '../../containers/mobile/footer';
import WinLineWrapper from '../../containers/common/winLineWrapper';
import FreeBetWrapper from '../../containers/common/freeBetWrapper';
import GameLogoWrapper from '../../containers/common/gameLogoWrapper';
import WinPopupWrapper from '../../containers/common/winPopupWrapper';
import InfoSectionContainer from '../../containers/common/infoWrapper';
import GameBoardWrapper from '../../containers/common/gameBoardWrapper';
import LobbyIconWrapper from '../../containers/common/lobbyIconWrapper';
import JackPotInfoWrapper from '../../containers/common/jackPotInfoWrapper';
import GameBackgroundWrapper from '../../containers/common/gameBackgroundWrapper';
import TournamentIconWrapper from '../../containers/common/tournamentIconWrapper';
import ConnectionPopupWrapper from '../../containers/common/connectionPopupWrapper';

import Gamble from '../../components/common/gamble';
import JackpotScene from '../../components/common/jackpotScene';
import ScaleComponent from '../../components/mobile/scaleComponent';
import MobileGameLayer from '../../components/mobile/mobileGameLayer';
import MobileBigWinLayer from '../../components/mobile/mobileBigWinLayer';
import JackPotCongratsPopup from '../../components/common/jackpot/jackPotCongratsPopup';
import RePlayInfoIconWrapper from '../../containers/common/rePlayInfoIconWrapper';

function MobileView({
  setMask,
  reelContainerRef,
  winContainerRef,
  touchSpinScreenRef,
  reelContainerConfig,
  touchSpinScreenConfig,
}) {
  return (
    <>
      <GameBackgroundWrapper />
      <ScaleComponent isCenterHorizontal childrenDefaultWidth={540}>
        <GameBoardWrapper
          setMask={setMask}
          winContainerRef={winContainerRef}
          reelContainerRef={reelContainerRef}
          reelContainerConfig={reelContainerConfig}
        />
        <Container ref={touchSpinScreenRef} {...touchSpinScreenConfig}>
          <Graphics
            draw={(g) => {
              g.clear();
              g.alpha = 0;
              g.interactive = true;
              g.beginFill(0x030303);
              g.drawRect(0, 0, touchSpinScreenConfig.width, touchSpinScreenConfig.height);
            }}
          />
        </Container>
        <GameLogoWrapper />
        <WinLineWrapper />
      </ScaleComponent>
      <MobileBigWinLayer />
      <ScaleComponent isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 540, 1);
          }}
        />
        <WinPopupWrapper />
        <MobileFooterContainer />
         <TournamentIconWrapper />
        <RePlayInfoIconWrapper />
        <Notification />
      </ScaleComponent>
      <ScaleComponent name='GameTopLayers' isCenterHorizontal>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 540, 1);
          }}
        />
        <JackPotInfoWrapper />
      </ScaleComponent>
      <LobbyIconWrapper />
      <MobileGameLayer name='Mobile Game Layer' />
      <ScaleComponent name='GameTopLayers' isCenterHorizontal childrenDefaultWidth={540}>
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0;
            g.interactive = false;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 540, 1);
          }}
        />
        <Gamble />
        <FreeBetWrapper />
        <InfoSectionContainer />
        <MenuWrapper />
      </ScaleComponent>
      <JackPotCongratsPopup />
      <JackpotScene />
      <ConnectionPopupWrapper />
    </>
  );
}

export default MobileView;
